import { Box } from '@mui/material';
import type { EChartsOption } from 'echarts';
import ReactECharts from 'echarts-for-react';
import { FC, useRef } from 'react';
import { useResizeDetector } from 'react-resize-detector';

type SimpleChartBarProps = {
  options: EChartsOption;
  minHeight?: number;
  loading?: boolean;
};

export const SimpleChartBar: FC<SimpleChartBarProps> = ({
  options,
  minHeight = 330,
  loading = false,
}) => {
  const echartRef = useRef<echarts.ECharts | null>(null);

  const { ref, width } = useResizeDetector<HTMLDivElement>({
    onResize: () => {
      // Resize the chart when container size changes
      if (echartRef.current) {
        echartRef.current.resize();
      }
    },
  });

  const onChartReady = (ref: echarts.ECharts) => {
    echartRef.current = ref;
  };

  return (
    <Box
      position="relative"
      width="100%"
      sx={{
        display: 'block',
        width: '100%',
      }}
      ref={ref}
    >
      <ReactECharts
        option={{ ...options, loading: loading ? { text: 'Loading...' } : undefined }}
        style={{
          width: '100%',
          minHeight,
          display: 'block',
        }}
        notMerge={true}
        onChartReady={onChartReady}
        opts={{
          width: width || 'auto',
          height: 'auto',
        }}
      />
    </Box>
  );
};

export default SimpleChartBar;
